import { Variation } from '@/@core/services/app.service'
import { TableColumnsType } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'
import {
  Stack,
  Typography,
  Box,
  Chip,
  IconButton,
  Badge,
  Slide
} from '@mui/material'

import Tooltip, { tooltipClasses, TooltipProps } from '@mui/material/Tooltip'
import { useContext } from 'react'
import { AbilityContext } from '@/layouts/components/acl/Can'
import { styled } from '@mui/material/styles'
import CommentOutline from 'mdi-material-ui/CommentOutline'
import { ExternalLinks } from '@/@core/services/api'
import { Circle, CircleHalfFull, MenuDown } from 'mdi-material-ui'
import {
  addCommas,
  chromosomeRegion,
  formatVariantInheritance,
  isJson,
  isWindow,
  renameChildTypes,
  unique
} from '@/@core/utils/utils'
import { useRouter } from 'next/router'
import { Rating } from '@mui/material'

interface Props {
  setCurrent: any
  data: any[]
  setColumn2: any
}
const HtmlTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  // [`& .${tooltipClasses.tooltip}`]: {
  //   backgroundColor: 'rgba(97, 97, 97)',
  //   color: 'rgb(255, 255, 255)',
  //   maxWidth: 220,
  //   fontSize: theme.typography.pxToRem(12),
  //   border: '1px solid #dadde9'
  // }
}))

const TypographyA = styled(Typography)(() => ({
  fontSize: '0.8rem',
  color: 'inherit'
}))

const Badges = styled(Badge)(({ theme }) => ({
  '& .MuiBadge-badge': {
    right: '-10px',
    backgroundColor: 'rgb(110,200,229)'
  },
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2)
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1)
  }
}))

const CustomWidthTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))({
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth: 500,
    maxHeight: 400,
    overflow: 'auto'
  }
})
const chromosome = [
  {
    text: 'chr1',
    value: '1'
  },
  {
    text: 'chr2',
    value: '2'
  },
  {
    text: 'chr3',
    value: '3'
  },
  {
    text: 'chr4',
    value: '4'
  },
  {
    text: 'chr5',
    value: '5'
  },
  {
    text: 'chr6',
    value: '6'
  },
  {
    text: 'chr7',
    value: '7'
  },
  {
    text: 'chr8',
    value: '8'
  },
  {
    text: 'chr9',
    value: '9'
  },
  {
    text: 'chr10',
    value: '10'
  },
  {
    text: 'chr11',
    value: '11'
  },
  {
    text: 'chr12',
    value: '12'
  },
  {
    text: 'chr13',
    value: '13'
  },
  {
    text: 'chr14',
    value: '14'
  },
  {
    text: 'chr15',
    value: '15'
  },
  {
    text: 'chr16',
    value: '16'
  },
  {
    text: 'chr17',
    value: '17'
  },
  {
    text: 'chr18',
    value: '18'
  },
  {
    text: 'chr19',
    value: '19'
  },
  {
    text: 'chr20',
    value: '20'
  },
  {
    text: 'chr21',
    value: '21'
  },
  {
    text: 'chr22',
    value: '22'
  },
  {
    text: 'chrX',
    value: 'X'
  },
  {
    text: 'chrY',
    value: 'Y'
  },
  {
    text: 'chrMT',
    value: 'MT'
  }
]

const color = [
  {
    key: 'pathogenic',
    value: 'pathogenic',
    color: 'rgba(229,38,35,0.8)'
  },
  {
    key: 'likely pathogenic',
    value: 'likely pathogenic',
    color: 'rgba(221,109,32,0.8)'
  },
  {
    key: 'drug response',
    value: 'drug response',
    color: 'rgb(46, 125, 50,0.8)'
  },
  {
    key: 'uncertain significance',
    value: 'uncertain significance',
    color: 'rgb(240,239,240,0.4)'
  },
  {
    key: 'likely benign',
    value: 'likely benign',
    color: 'rgb(107,148,200,0.8)'
  },
  {
    key: 'benign',
    value: 'benign',
    color: 'rgb(109,56,149,0.8)'
  },
  {
    key: 'loss of function',
    value: 'loss of function',
    color: 'rgb(237, 108, 2,0.8)'
  }
]

const GLScolor = [
  {
    key: 'pathogenic',
    value: 'pathogenic',
    color: 'rgb(218,150,148)'
  },
  {
    key: 'likely pathogenic',
    value: 'likely benign',
    color: 'rgb(245,182,193)'
  },
  {
    key: 'drug response',
    value: 'drug response',
    color: 'rgb(186,204,147)'
  },
  {
    key: 'uncertain significance',
    value: 'uncertain significance',
    color: 'rgb(240,239,240)'
  },
  {
    key: 'likely benign',
    value: 'likely benign',
    color: 'rgb(107,148,200)'
  },
  {
    key: 'benign',
    value: 'benign',
    color: 'rgb(64,113,190)'
  },
  {
    key: 'loss of function',
    value: 'loss of function',
    color: 'rgb(246,209,139)'
  }
]

export const judgeType = (str: string, arr: any[]) => {
  if (str.includes('child') && !str.includes('//')) {
    return 'C'
  } else if (str.includes('child') && str.includes('//')) {
    return `C${str.split('//')[1]}`
  } else if (str.includes('mother')) {
    return 'M'
  } else if (str.includes('father')) {
    return 'F'
  } else {
    return 'O'
  }
}

const columns2ThalassemiaPlot = React.forwardRef((props: Props, ref) => {
  const { t, i18n } = useTranslation()
  const ability = useContext(AbilityContext)

  const router = useRouter()

  const { id, ids, group } = router.query

  const type = router.asPath.includes('/samples') ? 'sample' : 'analyze'

  const column: any[] = React.useMemo(() => {
    return [
      {
        title: () => (
          <Stack maxWidth={'100%'} justifyContent="start" direction={'row'}>
            <Stack maxWidth={'100%'}>
              <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                {t('Regions')}
              </span>
            </Stack>
          </Stack>
        ),
        dataIndex: 'Regions',
        key: 'Regions',
        align: 'center',
        width: 100,
        ellipsis: true,
        sorter: false,
        render: (value: any, row: any) => {
          return (
            <Stack
              width={'100%'}
              marginTop={'12px'}
              direction="column"
              alignItems="start"
            >
              <TypographyA>Copy Number</TypographyA>
            </Stack>
          )
        }
      },
      {
        title: () => (
          <Stack maxWidth={'100%'} justifyContent="start" direction={'row'}>
            <Stack maxWidth={'100%'}>
              <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                {t('Mean')}
              </span>
            </Stack>
          </Stack>
        ),
        dataIndex: 'mean_cn',
        key: 'mean_cn',
        align: 'center',
        width: 100,
        ellipsis: true,
        sorter: false,
        render: (value: any, row: any) => {
          return (
            <Stack
              width={'100%'}
              marginTop={'12px'}
              direction="column"
              alignItems="start"
            >
              <TypographyA>{row.mean_cn}</TypographyA>
            </Stack>
          )
        }
      },
      ...props.data.map((items) => {
        return {
          title: () => (
            <Stack maxWidth={'100%'} justifyContent="start" direction={'row'}>
              <Stack maxWidth={'100%'}>
                <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                  {items.name}
                </span>
              </Stack>
            </Stack>
          ),
          dataIndex: items.name,
          key: items.name,
          align: 'center',
          width: 100,
          ellipsis: true,
          sorter: false,
          render: (value: any, row: any) => {
            if (items.name === row.name)
              return (
                <Stack
                  width={'100%'}
                  marginTop={'12px'}
                  direction="column"
                  alignItems="start"
                >
                  <HtmlTooltip
                    title={
                      <Box maxHeight={300} overflow="auto">
                        <Typography color={'white'}>
                          {items?.overlapping_records
                            ?.map((i: any) => i['raw.cn'])
                            .join(';')}
                        </Typography>
                      </Box>
                    }
                  >
                    <TypographyA
                      sx={{
                        maxWidth: 150,
                        overflow: 'hidden',
                        whiteSpace: 'nowrap',
                        textOverflow: 'ellipsis'
                      }}
                    >
                      {items?.overlapping_records
                        ?.map((i: any) => i['raw.cn'])
                        .join(';')}
                    </TypographyA>
                  </HtmlTooltip>
                </Stack>
              )
            else return ''
          }
        }
      })
    ]
  }, [props.data])

  React.useEffect(() => {
    //)

    props.setColumn2(column)
  }, [column])

  // React.useImperativeHandle(ref, () => ({
  //   column
  // }))

  return <></>
})

export default columns2ThalassemiaPlot
